export default "__VITE_ASSET__DWCSe17f__"